import { render, staticRenderFns } from "./PortalWyniki.vue?vue&type=template&id=50b5fb5b&"
import script from "./PortalWyniki.vue?vue&type=script&lang=js&"
export * from "./PortalWyniki.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports